import React from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import AppWrapper from "../../../components/AppWrapper/AppWrapper";
import Footer from "../../../components/Patient/Footer/Footer";
import { Helmet } from "react-helmet-async";
import Assistance from "../../../components/Patient/LandingPage/Assistance/Assistance";
import HeroSection from "../../../components/Patient/LandingPage/HeroSection/HeroSection";
import HowItWorks from "../../../components/Patient/LandingPage/HowItWorks/HowItWorks";
import NeedAssistance from "../../../components/Patient/LandingPage/NeedAssistance/NeedAssistance";
import Reviews from "../../../components/Patient/LandingPage/Reviews/Reviews";
import WhyAmericanClinic from "../../../components/Patient/LandingPage/WhyAmericanClinic/WhyAmericanClinic";
import Nav from "../../../components/Patient/Nav/Nav";
import { setCategioryId } from "../../../Redux/Actions/GeneralActions";
import AddToHomeScreen from "../../../components/Common/AddToHome";

function LandingPage() {
  const categioryID = useSelector((state) => state.auth.categioryId);
  const prescriptionRequest = useSelector(
    (state) => state.auth.prescriptionRequest
  );
  const user = useSelector((state) => state.auth.userData);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    // dispatch(setCategioryId(null))
    //   console.log('cat',categioryID)
    if (categioryID && user && prescriptionRequest) {
      if (categioryID?.type == "video") {
        navigate("/video-appointment");
      } else if (categioryID?.type == "urgent") {
        // navigate("/urgent-appointment");
      } else {
        navigate("/inPerson-appointment");
      }
    }
  }, []);
  return (
    <div>
      <Helmet>
        <title>American Clinic Online | Telehealth & Primary Care in English</title>
        <meta name="description" content="Connect with English-speaking doctors across Japan for urgent video consultations and primary healthcare. Prescriptions sent directly to a nearby pharmacy." />
        <link rel="canonical" href="https://www.americancliniconline.com/" />
        <meta property="og:title" content="American Clinic Online | Telehealth & Primary Care in English" />
        <meta property="og:description" content="Connect with English-speaking doctors across Japan for urgent video consultations and primary healthcare. Prescriptions sent directly to a nearby pharmacy." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.americancliniconline.com/" />
        <meta property="og:image" content="https://www.americancliniconline.com/images/AmericanClinic%20Online.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="American Clinic Online | Telehealth & Primary Care in English" />
        <meta name="twitter:description" content="Connect with English-speaking doctors across Japan for urgent video consultations and primary healthcare. Prescriptions sent directly to a nearby pharmacy." />
        <meta name="twitter:image" content="https://www.americancliniconline.com/images/AmericanClinic%20Online.png" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalClinic",
            name: "American Clinic Online",
            telephone: "+81-3-6441-0969",
            email: "info@americanclinictokyo.com",
            address: {
              "@type": "PostalAddress",
              addressLocality: "Tokyo",
              addressCountry: "JP",
            },
            geo: {
              "@type": "GeoCoordinates",
              latitude: 35.669295,
              longitude: 139.7394561,
            },
            areaServed: "Japan",
            medicalSpecialty: ["Telehealth", "Urgent Care", "General Practice"],
            availableService: [
              "Same-day Appointments",
              "Primary Care in English",
              "Urgent Video Consultations",
            ],
          })}
        </script>
      </Helmet>
      <AppWrapper>
        <div className="widthcontainer">
          <HeroSection />
          <HowItWorks />
          <WhyAmericanClinic />
          <Reviews />
          {/* <Assistance /> */}
          <NeedAssistance />
        </div>
      </AppWrapper>
    </div>
  );
}

export default LandingPage;
